import { state } from './state.js';
import { utils } from './utils.js';

export const stock = {
  check(qty) {
    const selections = state.getSelections();
    const insufficient = [];

    state.steps.forEach(step => {
      const sel = selections[step.id];
      if (!sel?.id_product) return;
      const stock = parseInt(sel.stock, 10) || 0;

      if (qty > stock) {
        insufficient.push({
          step: step.name,
          label: sel.label,
          stock,
          requested: qty,
          product: sel
        });
      }
    });

    return insufficient;
  },

  showError(items) {
    const minStock = Math.min(...items.map(i => i.stock));
    const html = `
      <div id="acpb-stock-modal" class="modal fade show" style="display:block;background:rgba(0,0,0,0.5);">
        <div class="modal-dialog modal-lg modal-dialog-centered">
          <div class="modal-content p-4">
            <div class="modal-header border-0">
              <h4 class="modal-title">${state.trad.stockErrorTitle}</h4>
              <button type="button" class="btn-close" id="acpb-close-stock"></button>
            </div>
            <div class="modal-body">
              <p>${state.trad.stockErrorMessage}</p>
              <ul class="list-group mb-3">
                ${items.map(i => `
                  <li class="list-group-item d-flex justify-content-between">
                    <span class="d-flex">${utils.stripHtml(i.step + ' - (' + i.label + ')')}</span>
                    <span class="d-flex flex-column">
                      <span><strong>${state.trad.stockErrorStock}</strong> : ${i.stock}</span>
                      <span><strong>${state.trad.stockErrorRequested}</strong> : ${i.requested}</span>
                    </span>
                  </li>`).join('')}
              </ul>
            </div>
            <div class="modal-footer border-0 justify-content-center">
              <button class="btn btn-primary" id="acpb-adjust">${state.trad.stockErrorAdjust} ${minStock}</button>
              <button class="btn btn-outline-secondary" id="acpb-edit">${state.trad.stockErrorEdit}</button>
            </div>
          </div>
        </div>
      </div>
    `;

    document.body.insertAdjacentHTML('beforeend', html);

    const close = () => document.getElementById('acpb-stock-modal')?.remove();

    document.getElementById('acpb-close-stock').onclick = close;
    document.getElementById('acpb-edit').onclick = close;
    document.getElementById('acpb-adjust').onclick = () => {
      state.elements.qtyInput.value = minStock;
      close();
    };
  }
};
